import { render, staticRenderFns } from "./BillingOrderDialogDeleteOrderItem.vue?vue&type=template&id=9f7125a2&scoped=true"
import script from "./BillingOrderDialogDeleteOrderItem.vue?vue&type=script&lang=js"
export * from "./BillingOrderDialogDeleteOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7125a2",
  null
  
)

export default component.exports